import { useInView } from "react-intersection-observer";

// styles
import "./HeroEl.css";

// images
import connectome400w from "@/assets/connectome/connectome-400w.avif";
import connectome800w from "@/assets/connectome/connectome-800w.avif";
import connectome1200w from "@/assets/connectome/connectome-1200w.avif";
import connectome1600w from "@/assets/connectome/connectome-1600w.avif";
// import connectome2000w from "./img/connectome-2000w.avif";

// --------------------------------------------------------------------------------------

export default function HeroEl() {
	// Shared image properties
	const imgSrc = connectome1200w;
	const imgSrcSet = `
		${connectome400w} 400w,
		${connectome800w} 800w,
		${connectome1200w} 1200w,
		${connectome1600w} 1600w
	`;
	// Careful: it is read in order, so don't put orientation: portrait before phone breakpoint. phones then would get 50vw instead of 72vw
	// leave 72vw as fallback, bcs on tablet (orientation: portrait), vw the img takes changes greatly (~30vw to ~70vw) so 50vw could undershoot, and you don't want lo-res img
	const imgSizes = "(orientation: landscape) 26vw, 72vw";
	const imgAlt =
		"A vibrant and detailed visualization of a human brain connectome.";

	// --------------------------------------------------------------------------------------

	// --- Intersection Observer ---
	const { ref, inView } = useInView({
		threshold: 0, // Trigger when 0% of the element is visible. It *does* turn off when off screen.
		triggerOnce: false, // Observe continuously, not just once
	});

	// Determine the class for animation based on inView state
	const animationClass = inView ? "is-animating" : "";

	// --------------------------------------------------------------------------------------

	return (
		<div className="hero-el" ref={ref}>
			{/* Text 1 */}
			<h1 className="h1-small">
				How&nbsp;much
				<br />
				USD&nbsp;to...
			</h1>

			{/* --------------------------------------------------------------------------- */}

			{/* Animation */}
			<div className="animation-flex-container">
				<div className="animation-inner-container">
					{/* Scanner bar */}
					<div className={`scanner-bar ${animationClass}`} />

					<div className={`img-clipper ${animationClass}`} aria-hidden="true">
						{/* filtered img */}
						<img
							className="filtered-img"
							src={imgSrc}
							srcSet={imgSrcSet}
							sizes={imgSizes}
							alt={imgAlt}
						/>
					</div>

					<div className={`img-clipper-2 ${animationClass}`} aria-hidden="true">
						{/* base img */}
						<img
							className="base-img"
							src={imgSrc}
							srcSet={imgSrcSet}
							sizes={imgSizes}
							alt={imgAlt}
						/>
					</div>
				</div>
			</div>

			{/* --------------------------------------------------------------------------- */}

			{/* Text 2 */}
			<h1 className="h1-big">
				emulate
				<br />
				a&nbsp;brain?
			</h1>
		</div>
	);
}
